// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3dnSr","left":"InfoRow_left__2VrQw"};